import React from "react";
import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import ManifestoStrip from "@/components/sections/ManifestoStrip";
import Services from "@/components/sections/Services";
import StickyShowcase from "@/components/sections/StickyShowcase";
import TechStack from "@/components/sections/TechStack";
import Process from "@/components/sections/Process";
import Work from "@/components/sections/Work";
import Testimonials from "@/components/sections/Testimonials";
import CTA from "@/components/sections/CTA";
import Footer from "@/components/sections/Footer";
import ScrollProgress from "@/components/ui-custom/ScrollProgress";

export default function LandingPage() {
  return (
    <main className="relative bg-black text-white">
      <ScrollProgress />
      <Navbar />
      <Hero />
      <ManifestoStrip />
      <Services />
      <StickyShowcase />
      <TechStack />
      <Process />
      <Work />
      <Testimonials />
      <CTA />
      <Footer />
    </main>
  );
}
